import Domains from './components';
import CreatePage from './CreatePage';
import DetailsPage from './DetailsPage';
import ListPage from './ListPage';
import VerifyBounceDomainPage from './VerifyBounceDomainPage';
import VerifySendingBounceDomainPage from './VerifySendingBounceDomainPage';
import VerifySendingDomainPage from './VerifySendingDomainPage';
import VerifyTrackingDomainPage from './VerifyTrackingDomainPage';

export default {
  ListPage,
  CreatePage,
  CreateDkimKeyPage: Domains.CreateDkimKeyPage,
  DkimKeyDetailsPage: Domains.DkimKeyDetailsPage,
  EditDkimKeyPage: Domains.EditDkimKeyPage,
  DetailsPage,
  VerifyBounceDomainPage,
  VerifySendingDomainPage,
  VerifySendingBounceDomainPage,
  VerifyTrackingDomainPage
};
